import { DecisionEnum } from '@/types';
import { z } from 'zod';

export const companyBlackListSchema = z
  .object({
    societeId: z.number().min(1, 'Ce champ est obligatoire'),
    natureDecision: z.enum(['TEMPORAIRE', 'DEFINITIVE'], {
      required_error: 'La décision est obligatoire',
    }),
    dateEffet: z.date({ required_error: 'Ce champ est obligatoire' }),
    delai: z.date().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.natureDecision === DecisionEnum.TEMPORAIRE) {
      if (!data.delai) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['delai'],
          message: 'La date limite est obligatoire pour une décision temporaire',
        });
        return;
      }

      if (data.delai <= data.dateEffet) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['delai'],
          message: 'La date limite doit être supérieure à la date d’effet',
        });
      }
    }
  });
